<template>
  <div :class="['accordion', 'mx-2xl']" @mouseleave="activeIndex = -1">
    <accordion-item
      v-for="(item, index) in parsedChildren"
      :key="item.title"
      :item="item"
      :is-active="
        dimensions.width < 1101 || $device.ipad || activeIndex === index
      "
      @mouseenter.native="activeIndex = index"
    >
    </accordion-item>
  </div>
</template>
<script>
import { mapState } from "vuex";
import AccordionItem from "./AccordionItem.vue";
export default {
  props: {
    children: {
      type: Array,
      required: true
    },
    size: String
  },
  components: { AccordionItem },
  data() {
    return {
      activeIndex: -1
    };
  },
  mounted() {
    console.log("$device > ", this.$device);
  },
  computed: {
    ...mapState(["dimensions"]),
    parsedChildren() {
      return _.filter(this.children, "url");
    }
  },
  methods: {
    activateItem: _.debounce(function(index) {
      this.activeIndex = index;
    }, 300)
  }
};
</script>
<style lang="stylus" scoped>
.btn-group
  _flex(column,wrap, stretch, flex-start)
  max-width 240px
  position relative
  z-index 2
.accordion
  margin-top 55px
  +below(600px, orientation: portrait)
    marg('2xl', top)
  +desktop()
    height 70vh
    _flex(row,wrap,stretch,space-evenly)
  +below(1100px)
    _flex(row,wrap,flex-start,space-between)
    flex-direction column !important
    width auto
    margin-left 0px !important
    margin-right 0px !important
    padding 0px 20px
    gap 20px
  @media (min-device-width: 1024px), (max-device-height: 1366px), (-webkit-min-device-pixel-ratio: 1.5)
    _flex(row,wrap,flex-start,space-between)
    height auto
</style>
